import api from '@/shared/utils/apiConfig';

export interface LoginPayload {
  /** Username, staff email, or staff phone. */
  username: string;
  password: string;
  deviceTrustToken?: string;
}

export interface LoginTwoFactorPayload {
  tempToken: string;
  code: string;
  rememberDevice?: boolean;
}

/** Auth endpoints used by AuthContext (login / password flows). */
export const authAPI = {
  login: async (payload: LoginPayload) => {
    const response = await api.post('/auth/login', payload);
    return response.data;
  },

  loginTwoFactor: async (payload: LoginTwoFactorPayload) => {
    const response = await api.post('/auth/login/2fa', {
      tempToken: payload.tempToken,
      code: payload.code,
      rememberDevice: Boolean(payload.rememberDevice),
    });
    return response.data;
  },

  updatePassword: async (passwordData: Record<string, unknown>) => {
    const response = await api.put('/auth/updatepassword', passwordData);
    return response.data;
  },

  forgotPassword: async (username: string) => {
    const response = await api.post('/auth/forgotpassword', { username });
    return response.data;
  },

  resetPassword: async (password: string, resetToken: string) => {
    const response = await api.put(`/auth/resetpassword/${resetToken}`, { password });
    return response.data;
  },
};
